(() => {
  if (window.lovegenTitleSearch) return;
  window.lovegenTitleSearch = true;

  // Scope every word separately: an unscoped second word searches all fields.
  function titleQuery(value) {
    const words = value.match(/[\p{L}\p{N}]+/gu) || [];
    return words.map(word => 'title:' + word + '*').join(' AND ');
  }
  function isScoped(value) {
    return /^title:[\p{L}\p{N}]+\*(?: AND title:[\p{L}\p{N}]+\*)*$/u.test(value);
  }
  const current = new URL(window.location.href);
  const searchPath = document.querySelector('form[role="search"]')?.getAttribute('action');
  if (searchPath && current.pathname === new URL(searchPath, current).pathname) {
    const query = current.searchParams.get('q') || '';
    const scoped = isScoped(query) ? query : titleQuery(query);
    if (isScoped(query)) {
      const label = query.replaceAll(' AND title:', ' ').replace(/^title:/, '').replaceAll('*', '');
      document.title = document.title.replace(query, label);
    }
    if (scoped && (query !== scoped || current.searchParams.get('type') !== 'product')) {
      current.searchParams.set('q', scoped);
      current.searchParams.set('type', 'product');
      current.searchParams.delete('page');
      window.location.replace(current.href);
      return;
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[role="search"]')) return;
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    event.preventDefault();
    const query = titleQuery(input.value);
    if (!query) { input.focus(); return; }
    const destination = new URL(form.action, window.location.origin);
    destination.search = new URLSearchParams(new FormData(form)).toString();
    destination.searchParams.set('q', query);
    destination.searchParams.set('type', 'product');
    const preview = current.searchParams.get('preview_theme_id');
    if (preview) destination.searchParams.set('preview_theme_id', preview);
    window.location.assign(destination.href);
  }, true);
})();
